import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { registerUser, adminActions } from "../store/adminSlice";
import Alert from "../components/Alert";
import validator from "../functions/Validator";

function SignUp() {
  const dispatch = useDispatch();
  const stateAlert = useSelector((state) => state.admin.alert);
  console.log(stateAlert);

  const [signupData, setSignupData] = useState({
    fullName: "",
    email: "",
    password: "",
    cPassword: "",
  });
  const [alert, SetAlert] = useState(false);
  const [aggrement, Setaggrement] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (signupData.password === signupData.cPassword) {
      dispatch(registerUser(signupData));
      SetAlert(true);
    } else {
      dispatch(
        adminActions.addAlert({
          type: "unsuccess",
          title: "UnsuccessFull",
          message: " Password Not Matched",
        })
      );
      SetAlert(true);
    }
  };

  const signIn = () => {
    dispatch(adminActions.removeAlert());
    navigate("/signin");
  };

  useEffect(() => {
    dispatch(adminActions.removeSignout);
  }, []);

  return (
    <div className="w-full min-h-screen bg-white flex flex-col items-center justify-center py-8 px-4">
      <div className="flex flex-col items-center mb-8">
        <img src="/logo-sdl.png" alt="SDL Logo" className="w-24 h-auto mb-4" />
        <h2 className="text-xl font-bold text-gray-800 text-center">
          Create Your SDL PRO Account
        </h2>
      </div>

      <div className="w-full max-w-md bg-white rounded-lg shadow-xl p-6 md:p-8">
        <form
          autoComplete="off"
          noValidate
          onSubmit={handleSubmit}
          className="space-y-6"
        >
          {alert && (
            <Alert
              type={stateAlert[0]}
              title={stateAlert[1]}
              message={stateAlert[2]}
            />
          )}

          <div className="flex justify-end">
            <p className="text-sm text-gray-600">
              Already have an account?
              <span
                className="ml-1 text-[#66c18a] hover:underline cursor-pointer font-medium"
                onClick={signIn}
              >
                Sign in
              </span>
            </p>
          </div>

          <div className="space-y-4">
            <div>
              <label
                htmlFor="fullName"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Full Name
              </label>
              <input
                id="fullName"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#66c18a] focus:border-[#66c18a] mobile-friendly-input"
                onChange={(e) =>
                  setSignupData({
                    ...signupData,
                    fullName: validator(e.target.value),
                  })
                }
                value={signupData.fullName}
                type="text"
                placeholder="Enter your full name"
              />
            </div>

            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Email
              </label>
              <input
                id="email"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#66c18a] focus:border-[#66c18a] mobile-friendly-input"
                autoComplete="off"
                onChange={(e) =>
                  setSignupData({
                    ...signupData,
                    email: validator(e.target.value),
                  })
                }
                value={signupData.email}
                type="email"
                placeholder="Enter your email"
              />
            </div>

            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Password
              </label>
              <input
                id="password"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#66c18a] focus:border-[#66c18a] mobile-friendly-input"
                onChange={(e) =>
                  setSignupData({
                    ...signupData,
                    password: validator(e.target.value),
                  })
                }
                value={signupData.password}
                type="password"
                placeholder="Create a password"
              />
            </div>

            <div>
              <label
                htmlFor="cPassword"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Confirm Password
              </label>
              <input
                id="cPassword"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#66c18a] focus:border-[#66c18a] mobile-friendly-input"
                onChange={(e) =>
                  setSignupData({
                    ...signupData,
                    cPassword: validator(e.target.value),
                  })
                }
                value={signupData.cPassword}
                type="password"
                placeholder="Confirm your password"
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="w-full py-2 px-4 bg-[#66c18a] hover:bg-[#59b37d] text-white font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#66c18a] transition-colors duration-200 mobile-friendly-button"
            >
              Create Account
            </button>
          </div>

          <div className="text-center">
            <button
              type="button"
              className="w-full py-2 px-4 border border-[#66c18a] text-[#66c18a] hover:bg-gray-50 font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#66c18a] transition-colors duration-200 mobile-friendly-button"
              onClick={() => navigate("/")}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SignUp;
